<template>
  <div>
    <div class="malware_dection">
      <img
        src="../../assets/img/search-malware.png"
        alt=""
        class="bg_malware"
        v-if="serviceName == 'Malware Detection Service'"
      />
      <img
        src="../../assets/img/search-url.png"
        alt=""
        class="bg_malware"
        v-if="serviceName == 'URL Filtering Service'"
      />
      <h3>{{ lang === 'en' ? serviceName : formatServiceName(serviceName) }}</h3>
      <div class="form">
        <span class="icon-search" v-if="loadingStatus">
          <img src="../../assets/img/icon-search.gif" alt="" />
        </span>
        <input
          type="text"
          :placeholder="$t('service.searchtxt1')"
          class="input_search"
          @keyup.enter="searchEnterFun"
          v-model="searchtxt"
          v-if="serviceName == 'Malware Detection Service'"
        />
        <input
          type="text"
          :placeholder="$t('service.searchtxt2')"
          class="input_search"
          @keyup.enter="searchEnterFun"
          v-model="searchtxt"
          v-if="serviceName == 'URL Filtering Service'"
        />
        <i
          class="el-icon-search"
          @click="searchMalware"
          v-if="serviceName == 'Malware Detection Service' && !loadingStatus"
        ></i>
        <i
          class="el-icon-search"
          @click="searchUrl"
          v-if="serviceName == 'URL Filtering Service' && !loadingStatus"
        ></i>
      </div>
      <div
        class="list"
        v-if="serviceName == 'Malware Detection Service' || serviceName == '病毒检测测试'"
      >
        <div v-if="malwareStatus">
          <div v-for="(item, index) in dataList" :key="index">
            <div class="screen_max">
              <span class="color_gray">{{ item.date }}</span>
              <span class="color_search">{{ item.md5 }}</span>
              <span :class="item.isMalicious ? 'color_light' : 'color_green'">{{ item.name }}</span>
            </div>
            <div class="screen_min">
              <div>
                <span class="color_search">{{ item.md5 }}</span>
                <div class="min_right">
                  <span :class="item.isMalicious ? 'color_light' : 'color_green'">{{
                    item.name
                  }}</span>
                  <span class="color_gray">{{ item.date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noData" v-if="!malwareStatus">
          <img src="../../assets/img/no_search.png" alt="" />
          <p>{{ $t('dashboard.noData') }}</p>
        </div>
      </div>
      <div
        class="list"
        v-if="serviceName == 'URL Filtering Service' || serviceName == 'URL网址测试'"
      >
        <div v-if="urlStatus">
          <div v-for="(item, index) in urlDataList" :key="index">
            <div class="screen_max">
              <span class="color_gray">{{ item.date }}</span>
              <span class="color_search">{{ item.url }}</span>
              <span :class="item.isMalicious ? 'color_light' : 'color_green'">{{ item.desc }}</span>
            </div>
            <div class="screen_min">
              <div>
                <span class="color_search">{{ item.url }}</span>
                <div class="min_right">
                  <span :class="item.isMalicious ? 'color_light' : 'color_green'">{{
                    item.desc
                  }}</span>
                  <span class="color_gray">{{ item.date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noData" v-if="!urlStatus">
          <img src="../../assets/img/no_search.png" alt="" />
          <p>{{ $t('dashboard.noData') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'
import { common } from '@/views/public/common'
export default {
  name: 'search',
  props: {
    serviceName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      searchtxt: '',
      dataList: {},
      urlDataList: {},
      malwareStatus: false,
      urlStatus: false,
      loadingStatus: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  methods: {
    formatDate: common.formatDate,
    formatServiceName(serviceName) {
      const serviceNames = {
        'Malware Detection Service': '病毒检测测试',
        'URL Filtering Service': 'URL网址测试'
      }
      return serviceNames[serviceName]
    },
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13) {
        if (this.serviceName == 'Malware Detection Service' || this.serviceName == '病毒检测测试') {
          this.searchMalware()
        }
        if (this.serviceName == 'URL Filtering Service' || this.serviceName == 'URL网址测试') {
          this.searchUrl()
        }
      }
    },
    searchMalware() {
      if (this.searchtxt) {
        this.loadingStatus = true
        axios
          .get(`/api/mobile/${this.searchtxt}`)
          .then(response => {
            this.loadingStatus = false
            this.searchtxt = ''
            var userInfoArr = JSON.parse(localStorage.getItem('userInfo1')) || []
            var obj = {
              date: this.formatDate(),
              md5: response.data.md5,
              name: response.data.name,
              isMalicious: response.data.isMalicious
            }
            userInfoArr.push(obj)
            localStorage.setItem('userInfo1', JSON.stringify(userInfoArr))
            this.getDataList()
          })
          .catch(err => {
            Message({
              type: 'error',
              message: err.response.data.statusCode + ' ' + err.response.data.message,
              showClose: true
            })
            this.loadingStatus = false
          })
      } else {
        Message({ type: 'error', message: this.$t('service.searchtxt1'), showClose: true })
      }
    },
    searchUrl() {
      if (this.searchtxt) {
        this.loadingStatus = true
        axios
          .get(`/api/url?url=${this.searchtxt}`)
          .then(response => {
            this.loadingStatus = false
            this.searchtxt = ''
            var urlInfoArr = JSON.parse(localStorage.getItem('urlInfo')) || []
            var obj1 = {
              date: this.formatDate(),
              url: response.data.url,
              desc: response.data.desc,
              isMalicious: response.data.isMalicious
            }
            urlInfoArr.push(obj1)
            localStorage.setItem('urlInfo', JSON.stringify(urlInfoArr))
            this.getUrlDataList()
          })
          .catch(err => {
            Message.error(err)
            this.loadingStatus = false
          })
      } else {
        Message({ type: 'error', message: this.$t('service.searchtxt2'), showClose: true })
      }
    },
    getDataList() {
      if (localStorage.getItem('userInfo1')) {
        var user = JSON.parse(localStorage.getItem('userInfo1'))
        if (user.length > 5) {
          user.splice(0, user.length - 5)
        }
        this.dataList = user.reverse()
        this.malwareStatus = true
      }
    },
    getUrlDataList() {
      if (localStorage.getItem('urlInfo')) {
        var urlUser = JSON.parse(localStorage.getItem('urlInfo'))
        if (urlUser.length > 5) {
          urlUser.splice(0, urlUser.length - 5)
        }
        this.urlDataList = urlUser.reverse()
        this.urlStatus = true
      }
    }
  },
  mounted() {
    this.getDataList()
    this.getUrlDataList()
  }
}
</script>
<style lang="scss" scoped>
.malware_dection {
  height: 280px;
  @include border-radius(6px);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  background: $white;
  position: relative;
  & > h3 {
    width: 100%;
    height: 83px;
    box-sizing: border-box;
    padding-top: 42px;
    font-size: 20px;
    text-align: center;
    font-family: NexaBold;
  }
  .form {
    width: 60%;
    max-width: 474px;
    height: 34px;
    background: #fbf5f1;
    @include border-radius(17px);
    border: 1px solid #f4c19b;
    position: relative;
    margin: 0 auto 20px;
    ::v-deep .icon-search {
      display: inline-block;
      width: 30px;
      height: 30px;
      @include absolute-right-top(-40px, 5px);
      & > img {
        width: 100%;
      }
    }
    .input_search {
      width: 85%;
      height: 100%;
      border: none;
      background: transparent;
      padding-left: 19px;
      color: #3d1601;
      font-size: 15px;
    }
    .el-icon-search {
      color: $primary-color;
      @include absolute-right-top(15px, 9px);
      font-size: 18px;
      cursor: pointer;
    }
  }
  .list {
    width: 100%;
    @include flex-justify-center;
    .noData {
      & > img {
        width: 70px;
        height: 70px;
        margin: 0 auto;
      }
      & > p {
        height: 12px;
        line-height: 23px;
        font-size: 12px;
        color: $primary-color;
        text-align: center;
      }
    }
    .screen_max {
      height: 12px;
      font-size: 12px;
      margin-bottom: 9px;
      color: #545454;
      .color_gray {
        color: #b8b8b8;
        margin-right: 5px;
      }
      .color_light {
        color: #f4001e;
        margin-left: 5px;
      }
      .color_green {
        color: #00b01f;
        margin-left: 5px;
      }
    }
    .screen_min {
      display: none;
    }
  }
  .bg_malware {
    width: 140px;
    height: 140px;
    @include absolute-left-top(0, 0);
  }
  .chat {
    width: 38px;
    height: 45px;
    @include absolute-right-top(-30px, 0);
  }
}
@media screen and (max-width: 450px) {
  .malware_dection {
    min-height: 280px;
    height: auto;
    & > h3 {
      width: 100%;
      height: 48px;
      line-height: 48px;
      box-sizing: border-box;
      padding-top: 4px;
      font-size: 14px;
      text-align: center;
    }
    .form {
      width: 80%;
      height: 24px;
      .el-icon-search {
        @include absolute-right-top(8px, 7px);
        font-size: 12px;
      }
      .input_search {
        font-size: 12px;
      }
    }
    .bg_malware {
      width: 60px;
      height: 60px;
    }
    .list {
      .screen_max {
        display: none;
      }
      .screen_min {
        display: block;
        box-sizing: border-box;
        & > div {
          @include flex-space-center;
          font-size: 12px;
          line-height: 15px;
          font-family: Lato-Regular;
          font-weight: 400;
          border-bottom: 1px solid rgba(243, 246, 254, 1);
          padding: 5px 0;
          box-sizing: border-box;
          .color_search {
            display: inline-block;
            height: auto;
            width: 140px;
            color: rgba(31, 37, 62, 1);
            word-wrap: break-word;
          }
          .min_right {
            height: 32px;
            text-align: right;
            .color_gray,
            .color_light,
            .color_green {
              display: block;
              height: 15px;
            }
            .color_light,
            .color_green {
              font-family: Lato-Regular;
              font-weight: 500;
            }
            .color_gray {
              color: #b8b8b8;
              margin-bottom: 2px;
              font-size: 10px;
            }
            .color_light {
              color: #f4001e;
            }
            .color_green {
              color: #00b01f;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/search.vue